/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type {
  Signer,
  AddressLike,
  ContractDeployTransaction,
  ContractRunner,
} from "ethers";
import type { NonPayableOverrides } from "../../common";
import type {
  UserBMPurchaser,
  UserBMPurchaserInterface,
} from "../../contracts/UserBMPurchaser";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IRewardVault",
        name: "vault_",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "ClaimWithNativeError",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "OwnableInvalidOwner",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "OwnableUnauthorizedAccount",
    type: "error",
  },
  {
    inputs: [],
    name: "RewardQuoteEqualityError",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "UnknownMarketError",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "available",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amountNeeded",
        type: "uint256",
      },
    ],
    name: "UserHasNotEnoughRewardError",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IBondAggregator",
        name: "bondAggregator_",
        type: "address",
      },
      {
        internalType: "address",
        name: "referrer_",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "minAmountOut_",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "needClaimForPurchase_",
        type: "bool",
      },
    ],
    name: "purchaseForMe",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint48",
        name: "",
        type: "uint48",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "rewardVault",
    outputs: [
      {
        internalType: "contract IRewardVault",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IRewardVault",
        name: "vault_",
        type: "address",
      },
    ],
    name: "setVaultForClaims",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
] as const;

const _bytecode =
  "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";

type UserBMPurchaserConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: UserBMPurchaserConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class UserBMPurchaser__factory extends ContractFactory {
  constructor(...args: UserBMPurchaserConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    vault_: AddressLike,
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(vault_, overrides || {});
  }
  override deploy(
    vault_: AddressLike,
    overrides?: NonPayableOverrides & { from?: string }
  ) {
    return super.deploy(vault_, overrides || {}) as Promise<
      UserBMPurchaser & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): UserBMPurchaser__factory {
    return super.connect(runner) as UserBMPurchaser__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): UserBMPurchaserInterface {
    return new Interface(_abi) as UserBMPurchaserInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): UserBMPurchaser {
    return new Contract(address, _abi, runner) as unknown as UserBMPurchaser;
  }
}
